export default "__VITE_ASSET__c6e1cc85__"